module.exports = __webpack_public_path__ + "media/images/close-bd201370.svg";